class NotificationPopup extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.id = this.dataset.id;
    if (!this.id || this.alreadyOpen()) return;
    this.classList.add("notification-popup--active");
    this.addEventListener("click", this.#handleClick);
  }

  alreadyOpen() {
    if (localStorage.getItem(`notification-${this.id}`)) {
      this.classList.remove("notification-popup--active");
      return true;
    }
  }

  #handleClick() {
    if (this.alreadyOpen()) return;
    this.classList.remove("notification-popup--active");
    localStorage.setItem(`notification-${this.id}`, true);
  }
}

customElements.define("notification-popup", NotificationPopup);
